module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-137.ca06344.woff2";